import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";
import * as Sentry from '@sentry/nextjs';
export var loggerReporter = {
  onError: function onError(context, error) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (error instanceof Error) {
                Sentry.captureException(error, {
                  extra: {
                    context: context
                  }
                });
              } else if (typeof error === 'string') {
                Sentry.captureMessage(error, {
                  extra: {
                    context: context
                  }
                });
              } else {
                Sentry.captureMessage("Fatal: ".concat(error), {
                  extra: {
                    context: context
                  }
                });
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  registerUser: function registerUser(context, message, user) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              Sentry.addBreadcrumb({
                category: "[".concat(context, "] register-user"),
                message: message
              });
              Sentry.setUser({
                id: user.id,
                email: user.email,
                username: user.name
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  removeUser: function removeUser(context, message) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              Sentry.addBreadcrumb({
                category: "[".concat(context, "] remove-user"),
                message: message
              });
              Sentry.setUser(null);

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};